// ============================================================================
// 型定義ファイル
// ============================================================================

// Re-export API types
export type { User, Entry, TagsResponse, PreviewResponse, Subscription } from '@/lib/api';

// --- Mood ---
export interface MoodOption {
  id: string;
  emoji: string;
  label: string;
}

export const moodOptions: MoodOption[] = [
  { id: 'happy', emoji: '😊', label: '嬉しい' },
  { id: 'calm', emoji: '😌', label: '穏やか' },
  { id: 'excited', emoji: '🤩', label: 'ワクワク' },
  { id: 'tired', emoji: '😴', label: '疲れた' },
  { id: 'sad', emoji: '😢', label: '悲しい' },
  { id: 'angry', emoji: '😤', label: 'イライラ' },
  { id: 'anxious', emoji: '😰', label: '不安' },
  { id: 'neutral', emoji: '😐', label: '普通' },
];

export const FALLBACK_TAGS = [
  'work', 'health', 'family', 'hobby', 'study', 'exercise',
  'food', 'travel', 'friends', 'entertainment', 'daily', 'reflection',
];

/** @deprecated Use getEntryIcon instead. Kept for backward compatibility with old entries. */
export function getMoodByText(moodText: string): MoodOption | undefined {
  return moodOptions.find(m => moodText.includes(m.emoji) || moodText.includes(m.label) || moodText.includes(m.id));
}

export function getEntryIcon(entry: { icon?: string; mood?: string }): string {
  if (entry.icon) return entry.icon;
  if (entry.mood) {
    const match = getMoodByText(entry.mood);
    if (match) return match.emoji;
  }
  return '📝';
}

export function getSentimentDisplay(score: number): { color: string; bgColor: string; label: string } {
  if (score <= -0.5) return { color: 'text-red-500', bgColor: 'bg-red-500', label: 'つらい' };
  if (score <= -0.1) return { color: 'text-orange-500', bgColor: 'bg-orange-500', label: 'やや落ち込み' };
  if (score <= 0.2) return { color: 'text-yellow-500', bgColor: 'bg-yellow-500', label: '穏やか' };
  if (score <= 0.5) return { color: 'text-lime-500', bgColor: 'bg-lime-500', label: '前向き' };
  return { color: 'text-green-500', bgColor: 'bg-green-500', label: 'とても前向き' };
}

// --- Visualizer Config ---
export interface VisualizerConfig {
  barWidth: number;
  barGap: number;
  primaryColor: string;
  secondaryColor: string;
  smoothingTimeConstant: number;
  fftSize: number;
}

export const DEFAULT_VISUALIZER_CONFIG: VisualizerConfig = {
  barWidth: 3,
  barGap: 2,
  primaryColor: '#4F46E5',
  secondaryColor: '#818CF8',
  smoothingTimeConstant: 0.8,
  fftSize: 256,
};
